export default __webpack_public_path__ + "images/todo-list-icon.svg";